<template>
  <!-- 历史会议相关 -->
  <div class="list-layout-box" :class="[{'permit-nav':mobNavShow}]">
    <div class="top-fix-container">
      <back-route-hdr :back-mode="'static'"></back-route-hdr>
      <van-search v-model="searchText" show-action :placeholder="`搜索会议或${roomTitle}`"
                  class="bord-btm" @search="searchSubmit">
        <template #action>
          <div @click="clearBack">清空</div>
        </template>
      </van-search>
      <van-dropdown-menu class="custom-tree-filter">
        <!-- 时间筛选 -->
        <van-dropdown-item ref="date">
          <template #title>
            <span class="mar-lft-5">{{dateText ? dateText : '选择时间区间'}}</span>
            <van-badge :dot="!!filterDateDoc.start"></van-badge>
          </template>
          <van-calendar :poppable="false" :show-title="false" color="#2D69E0"
                        :min-date="minDate" :max-date="maxDate" :formatter="formatDate"
                        :style="{ height:'450px'}" :default-date="date" type="range"
                        @confirm="onConfirmDate"></van-calendar>
        </van-dropdown-item>
        <van-dropdown-item ref="filter">
          <template #title>
            <i class="fa fa-filter" :class="Object.keys(destCondition).length ? 'text-danger' : ''">
              <span class="mar-lft-5">筛选</span>
            </i>
          </template>
          <div class="bord-ver bg-white">
            <van-tree-select class="bord-btm"
                             :items="treeList"
                             :main-active-index.sync="active">
              <template #content>
                <div v-for="(item, index) in treeList" :key="item.key">
                  <!-- 多选 -->
                  <van-checkbox-group v-if="item.multi" v-show="active===index"
                                      v-model="filterRc[item.key]">
                    <van-cell-group>
                      <van-cell v-for="(ele, idx) in item.children" clickable :key="ele.value"
                                :title="ele.label" @click="toggleChoice(item.key, idx)">
                        <template #right-icon>
                          <van-checkbox :name="ele.value" :ref="item.key"
                                        shape="square" icon-size="14px"></van-checkbox>
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-checkbox-group>

                  <!-- 单选 -->
                  <van-radio-group v-else v-show="active===index" v-model="filterRc[item.key]">
                    <van-cell-group class="bord-no">
                      <van-cell v-for="ele in item.children" :key="ele.value"
                                :title="ele.label" clickable class="bord-no"
                                @click="filterRc[item.key] = ele.value">
                        <template #right-icon>
                          <van-radio :name="ele.value"></van-radio>
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </van-radio-group>
                </div>
              </template>
            </van-tree-select>

            <van-row gutter="20" class="mar-all">
              <van-col span="12">
                <van-button block size="small" @click="clearBack">重置</van-button>
              </van-col>
              <van-col span="12">
                <van-button block size="small" type="primary" @click="filterData">确定</van-button>
              </van-col>
            </van-row>
          </div>
        </van-dropdown-item>
      </van-dropdown-menu>
    </div>
    <van-list v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              class="custom-steps ctn-mar-md">
      <!-- 列表开始 -->
      <meeting-list-cell v-for="(ele, idx) in rowData" :key="idx" class="mar-top-10"
                         :formatted-mt="ele" :show-date-time="true"
                         @click-cell="handleDetail(ele)">
      </meeting-list-cell>
    </van-list>

  </div>
</template>

<script>
  import {formatMListDoc, checkShowPermit, savePagePosition, removePagePosition} from "../../../../tools/utils"
  import {meeting} from "../../../../server";
  import {getStorage, StorageKey} from "../../../../tools/storage";
  import routerMeta from "../../router/routerMeta";
  import MeetingListCell from "../../components/MeetingListCell"
  import {commonConfig, momentFormat} from "../../../../config/common";

  const filterKeys = {
    meetingModesIdx: "meetingModesIdx",
    meetingStatusIdx: "meetingStatusIdx",
  };
  export default {
    components: {
      MeetingListCell,
    },
    data() {
      return {
        active: 0,
        userId: getStorage(StorageKey.userId),
        searchText: '',
        filterDateDoc: {
          // 结束日期默认今日
          end: moment().endOf('day').subtract(1, "day").valueOf(),
        },
        filterDataDoc: {},
        dateText: '',
        date: moment().toDate(),
        dateRangeDoc: (new Date()).valueOf(),
        today: moment().format(momentFormat.date),
        filterRc: {
          [filterKeys.meetingModesIdx]: '',
          [filterKeys.meetingStatusIdx]: [],
        },
        meetingData: [],
        pageInfo: {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        },
        finished: false,
        loading: false,
        reset: false
      }
    },
    computed: {
      roomTitle() {
        return this.$store.state.formTitles.meetingRoom
      },
      dateCN() {
        return this.date && moment(this.date).format(momentFormat.date)
      },
      rowData: function () {
        return this.meetingData.map(ele => formatMListDoc(ele, this))
      },
      // 时间范围默认3个月
      minDate() {
        return moment().subtract(90, 'day').startOf('day').toDate()
      },
      maxDate() {
        return moment(this.minDate).add(89, 'day').endOf('day').toDate()
      },
      treeList() {
        const arr = [
          {
            text: "会议形式",
            children: Object.values(commonConfig.meetingModesFilter),
            dot: Boolean(this.filterRc.meetingModesIdx),
            key: filterKeys.meetingModesIdx,
          },
          {
            text: "会议状态",
            children: Object.values(commonConfig.meetingStatusFilter),
            dot: Boolean(this.filterRc.meetingStatusIdx.length),
            key: filterKeys.meetingStatusIdx,
            multi: true
          }
        ];
        return arr
      },
      destCondition() {
        let condition = {};
        this.treeList.forEach(item => {
          switch (item.key) {
            case filterKeys.meetingModesIdx:
              if (this.filterRc.meetingModesIdx) {
                this.filterDataDoc.meetingMode = this.filterRc.meetingModesIdx;
                condition.meetingModesIdx = this.filterRc.meetingModesIdx;
              }
              return;
            case filterKeys.meetingStatusIdx:
              this.filterDataDoc.meetingStatus = this.filterRc.meetingStatusIdx;
              if (this.filterRc.meetingStatusIdx.length) {
                condition.meetingStatusIdx = this.filterRc.meetingStatusIdx;
              }
              return;
            default:
              if (filterKeys.hasOwnProperty(item.key)) {
                if (this.filterRc[item.key].length) {
                  condition[[item.key]] = this.filterRc[item.key];
                }
                return;
              }
              break;
          }
        });
        return condition
      },
      mobNavShow() {
        const permissionList = this.$store.state.permissionList || [];
        return checkShowPermit(permissionList, this.permitsMap.mobNav)
      }
    },
    methods: {
      onLoad() {
        if (this.reset) {
          this.reset = false
          return
        }
        this.loadMeeting(this.pageInfo.pageNum++, this.filterDateDoc)
      },
      searchSubmit() {
        this.meetingData = []
        this.loadMeeting(1, this.filterDateDoc)
      },
      filterData() {
        this.$refs['filter'].toggle();
        this.meetingData = []
        this.loadMeeting(1, this.filterDateDoc)
      },
      // 清空筛选条件
      clearBack() {
        this.meetingData = []
        this.searchText = '';
        this.finished = false;
        this.dateText = '选择时间区间';
        this.date = moment().toDate();
        this.filterRc = {
          [filterKeys.meetingModesIdx]: '',
          [filterKeys.meetingStatusIdx]: [],
        }
        this.filterDataDoc = {};
        this.filterDateDoc = {
          end: moment().endOf('day').subtract(1, "day").valueOf(),
        };
        this.pageInfo = {
          pageSize: 10,
          pageNum: 1,
          pages: 1,
        }
        this.reset = true
        this.loadMeeting(1, this.filterDateDoc, true)
      },
      toggleChoice(key, index) {
        this.$refs[key][index].toggle()
      },
      onConfirmDate(date) {
        this.meetingData = [];
        this.$refs['date'].toggle();
        const [start, end] = date;
        this.dateText = `${moment(start).format().split('T')[0]} - ${moment(end).format().split('T')[0]}`;
        this.filterDateDoc = {
          start: moment(start).valueOf(),
          end: moment(end).valueOf(),
        }
        this.loadMeeting(1, this.filterDateDoc);
      },
      formatDate(day) {
        if (moment(day.date).format(momentFormat.date) === this.today) {
          day.bottomInfo = '今天';
        }
        return day
      },
      loadMeeting(pageNum = 1, filterDateDoc, reset) {
        // 初次加载时显示加载圈 查询会议记录
        let sel = {
          dateRange: {...this.filterDateDoc},
          textField: this.searchText,
          ...this.filterDataDoc
        }
        meeting.queryList(this, {
          queryFilter: {
            pageNum,
            pageSize: this.pageInfo.pageSize,
            createdBy: this.userId,
            userId: this.userId,
            ccUserId: this.userId,
            getIsUserCheckin: true,
            ...sel
          }
        }).then(({searchMeeting: data = {}}) => {
          this.loading = false;
          const {meetingEdges, pageInfo} = data;
          //判断是否点击重置
          if (reset) {
            this.meetingData = meetingEdges
          } else {
            this.meetingData = this.meetingData.concat(meetingEdges);
          }
          this.pageInfo.pages = Math.ceil((pageInfo.total || 0) / this.pageInfo.pageSize);
          if (!pageInfo.total || pageNum >= this.pageInfo.pages) {
            this.finished = true
          }
        }).catch(err => {
          this.loading = false;
          this.finished = true;
          // console.log(err);
          vtToast(err.message)
        })
      },
      changeDate(date) {
        // console.log(moment(date).format(momentFormat.date))
        this.date = date;
      },
      handleDetail(doc) {
        savePagePosition('history')
        this.$router.push({name: routerMeta.meetingDetailFromHistory.name, params: {mid: doc.mid}})
      },
    },
    activated() {
      window.scroll(0, localStorage.getItem("history"))
      removePagePosition()
    },
    beforeRouteLeave(to, from, next) {
      // 只有在跳转到详情页时才需要保持当前页面
      from.meta.keepAlive = to.name === routerMeta.meetingDetailFromHistory.name;
      next();
    }
  }
</script>

<style lang="less" scoped>
  .custom-tree-filter {
    .van-dropdown-menu__bar {
      height: 35px !important;
    }

    .van-dropdown-menu__title {
      font-size: 13px;
    }

    .van-popup .van-button {
      border: 1px solid #ebedf0;
    }

    .van-popup .van-cell::after {
      border-bottom: 1px solid #ebedf0;
    }
  }
</style>
